import deliverUserEvent from './deliver-user-event';

interface EventData {
  portalUrl?: string;
  esriUserId?: string;
  esriLicenseTypeId?: string;
  esriOrgId?: string;
}

interface EventPayload {
  'Portal Url'?: string;
  'Esri User Id'?: string;
  'Esri License Type Id'?: string;
  'Esri Org Id'?: string;
}

const buildEventData = (eventData: EventData): string => {
  const {
    portalUrl, esriUserId, esriLicenseTypeId, esriOrgId,
  } = eventData;
  const data: EventPayload = {};

  if (portalUrl) {
    data['Portal Url'] = portalUrl;
  }
  if (esriUserId) {
    data['Esri User Id'] = esriUserId;
  }
  if (esriLicenseTypeId) {
    data['Esri License Type Id'] = esriLicenseTypeId;
  }
  if (esriOrgId) {
    data['Esri Org Id'] = esriOrgId;
  }

  return JSON.stringify(data);
};

export default async function arcgisLoginEvent(eventData: EventData) {
  const payload = await eventPayload(eventData);

  return deliverUserEvent(payload);
}

export const eventPayload = async (
  eventData: EventData,
): Promise<FormData> => {
  const isEnterprise = !!eventData?.portalUrl;

  const payload = new FormData();
  payload.append('event_type', isEnterprise ? 'arcgis-enterprise' : 'arcgis-online');
  payload.append('event_action', 'signed-in');
  payload.append('event_data', buildEventData(eventData ?? {}));

  return payload;
};
